/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Jr_OverlineInputs */

const en_cp_jr_overline = /** @type {(inputs: Cp_Jr_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`STAGES`)
};

const id_cp_jr_overline = /** @type {(inputs: Cp_Jr_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TAHAPAN`)
};

/**
* | output |
* | --- |
* | "STAGES" |
*
* @param {Cp_Jr_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_jr_overline = /** @type {((inputs?: Cp_Jr_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Jr_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_jr_overline(inputs)
	return en_cp_jr_overline(inputs)
});